/**
 * GO4 GoDEX outside-only label stock (portrait reflow).
 * Same physical size as carrier shippingLabel PDFs: 3.94 × 5.91 in.
 * Content is Cheetah outside face only — never stub / items / prices.
 */

export const GO4_OUTSIDE_LABEL = Object.freeze({
  id: 'go4-outside',
  label: 'GO4 GoDEX outside label',
  /** Inches (QZ / driver stock name) */
  widthIn: 3.94,
  heightIn: 5.91,
  /** Millimetres (exact match to shippingLabel profile) */
  widthMm: 100.076,
  heightMm: 150.114,
  padMm: 3,
  contentTopBreathingMm: 1.5,
  /**
   * Portrait reflow — no letterbox of Cheetah 160×105.
   * Locked at 0 so CSS top of .go4-outside-page is the physical leading edge
   * of Godex RT730i Continuous Roll (same convention as carrier 3.94×5.91).
   * Brand row (logo left, order QR right) is the first block at that top;
   * any future rotate applies only to .lz-label__body under the row, never
   * to the logo or QR.
   */
  contentRotationDeg: 0,
  /** Prefer readable QR on taller stock */
  qrFloorMm: 16,
  logoWidthMm: 26,
  /**
   * Top of portrait face (leading edge): logo left, order QR right, same row.
   * Markup class on `.lz-label__mark` when GO4 `logoAtTop` is on.
   */
  brandRowClass: 'go4-outside-brand-row',
});

/**
 * Inner content box after pad + top breathing (mm).
 * @param {typeof GO4_OUTSIDE_LABEL} [stock]
 */
export function getGo4OutsideContentBoxMm(stock = GO4_OUTSIDE_LABEL) {
  const pad = Number(stock.padMm) || 0;
  const topBreath = Number(stock.contentTopBreathingMm) || 0;
  return {
    widthMm: Math.max(1, Number(stock.widthMm) - pad * 2),
    heightMm: Math.max(1, Number(stock.heightMm) - pad * 2 - topBreath),
    padMm: pad,
    topBreathingMm: topBreath,
    contentRotationDeg: Number(stock.contentRotationDeg) || 0,
  };
}

export default GO4_OUTSIDE_LABEL;
